import React, { useState } from "react";
import { NavLink as RouterNavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  Collapse,
  Container,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { useAuth0 } from "@auth0/auth0-react";
import { useSelector } from "react-redux";

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    user,
    isAuthenticated: auth0IsAuthenticated,
    loginWithRedirect,
    logout,
  } = useAuth0();
  const toggle = () => setIsOpen(!isOpen);

  // Auth0's isAuthenticated stays true after a session expires mid-use, since
  // the SDK only re-checks on load. Treating an expired session as logged out
  // is what surfaces the Log in button again instead of leaving the user with a
  // profile menu and an error they cannot act on.
  const sessionExpired = useSelector((state) => state.auth.sessionExpired);
  const isAuthenticated = auth0IsAuthenticated && !sessionExpired;

  const logoutWithRedirect = () => {
    sessionStorage.removeItem('token');
    logout({
      returnTo: window.location.origin,
    });
  }

  const roles = user != null && user["http://exoticcartrader.com/role"];

  return (
    <div className="nav-container" style={{ width: '100%' }}>
      <Navbar color="light" light expand="md">
        <Container>
          <NavbarBrand className="logo" />
          <NavbarToggler onClick={toggle} />
          <Collapse isOpen={isOpen} navbar>
            <Nav className="mr-auto" navbar>
              <NavItem>
                <NavLink
                  tag={RouterNavLink}
                  to="/"
                  exact
                  activeClassName="router-link-exact-active"
                >
                  Home
                </NavLink>
              </NavItem>
              {isAuthenticated && roles.includes("Photographer") && (
                <NavItem>
                  <NavLink
                    tag={RouterNavLink}
                    to="/my-shoots"
                    exact
                    activeClassName="router-link-exact-active"
                  >
                    My Shoots
                  </NavLink>
                </NavItem>
              )}
              {isAuthenticated && (roles.includes("Editor") || roles.includes("Blogger")) && (
                <NavItem>
                  <NavLink
                    tag={RouterNavLink}
                    to="/jobs"
                    exact
                    activeClassName="router-link-exact-active"
                  >
                    Available Jobs
                  </NavLink>
                </NavItem>
              )}
              {isAuthenticated && (roles.includes("Editor") || roles.includes("Blogger")) && (
                <NavItem>
                  <NavLink
                    tag={RouterNavLink}
                    to="/my-jobs"
                    exact
                    activeClassName="router-link-exact-active"
                  >
                    My Jobs
                  </NavLink>
                </NavItem>
              )}
              {isAuthenticated && roles.includes("Photography Manager") && (
                <NavItem>
                  <NavLink
                    tag={RouterNavLink}
                    to="/shoots"
                    exact
                    activeClassName="router-link-exact-active"
                  >
                    Manage Shoots
                  </NavLink>
                </NavItem>
              )}
              {isAuthenticated && roles.includes("Photography Manager") && (
                <NavItem>
                  <NavLink
                    tag={RouterNavLink}
                    to="/photographer-search"
                    exact
                    activeClassName="router-link-exact-active"
                  >
                    Photographer Search
                  </NavLink>
                </NavItem>
              )}
              {isAuthenticated && roles.includes("Photography Manager") && (
                  <NavItem>
                    <NavLink
                        tag={RouterNavLink}
                        to="/manual-payment"
                        exact
                        activeClassName="router-link-exact-active"
                    >
                      Manual Payment
                    </NavLink>
                  </NavItem>
              )}
              {isAuthenticated && (roles.includes("Editor Manager") ||  roles.includes("Blogger Manager"))&& (
                  <NavItem>
                    <NavLink
                        tag={RouterNavLink}
                        to="/manage-jobs"
                        exact
                        activeClassName="router-link-exact-active"
                    >
                      Manage Jobs
                    </NavLink>
                  </NavItem>
              )}
            </Nav>
            <Nav className="d-none d-md-block" navbar>
              {!isAuthenticated && (
                <NavItem>
                  <Button
                    id="qsLoginBtn"
                    color="primary"
                    className="btn-margin"
                    onClick={() => loginWithRedirect({ redirectUri: window.location.origin + "/redirect" })}
                  >
                    Log in
                  </Button>
                </NavItem>
              )}
              {isAuthenticated && (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret id="profileDropDown">
                    <img
                      src={user.picture}
                      alt="Profile"
                      className="nav-user-profile rounded-circle"
                      width="50"
                    />
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem header>{user.name}</DropdownItem>
                    <DropdownItem
                      tag={RouterNavLink}
                      to="/profile"
                      className="dropdown-profile"
                      activeClassName="router-link-exact-active"
                    >
                      <FontAwesomeIcon icon="user" className="mr-3" /> Profile
                    </DropdownItem>
                    <DropdownItem
                      id="qsLogoutBtn"
                      onClick={() => logoutWithRedirect()}
                    >
                      <FontAwesomeIcon icon="power-off" className="mr-3" /> Log
                      out
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
            </Nav>
            {!isAuthenticated && (
              <Nav className="d-md-none" navbar>
                <NavItem>
                  <Button
                    id="qsLoginBtn"
                    color="primary"
                    block
                    onClick={() => loginWithRedirect({ redirectUri: window.location.origin + "/redirect" })}
                  >
                    Log in
                  </Button>
                </NavItem>
              </Nav>
            )}
            {isAuthenticated && (
              <Nav
                className="d-md-none justify-content-between"
                navbar
                style={{ minHeight: 170 }}
              >
                <NavItem>
                  <span className="user-info">
                    <img
                      src={user.picture}
                      alt="Profile"
                      className="nav-user-profile d-inline-block rounded-circle mr-3"
                      width="50"
                    />
                    <h6 className="d-inline-block">{user.name}</h6>
                  </span>
                </NavItem>
                <NavItem>
                  <FontAwesomeIcon icon="user" className="mr-3" />
                  <RouterNavLink
                    to="/profile"
                    activeClassName="router-link-exact-active"
                  >
                    Profile
                  </RouterNavLink>
                </NavItem>
                <NavItem>
                  <FontAwesomeIcon icon="power-off" className="mr-3" />
                  <RouterNavLink
                    to="#"
                    id="qsLogoutBtn"
                    onClick={() => logoutWithRedirect()}
                  >
                    Log out
                  </RouterNavLink>
                </NavItem>
              </Nav>
            )}
          </Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default NavBar;
